import { rHandler } from '@/plugins/response-handler';
import APIService from '@/services/APIService';

export default class BaseModel {
  constructor(id, url) {
    this.id = id;
    this.url = url;

    this.onChange = () => ({});
  }

  bind(eventName, callback) {
    this[eventName] = callback;
  }

  /**
   * @param {
   *  data: Object
   *  obs: ValidationObserver
   * } rParams - request parameters
   */
  async update({ data, obs }) {
    const merged = { ...data };
    const resp = await APIService.put(
      `${this.url}/${this.id}`, merged, { rOptions: { obs } },
    );
    Object.assign(this, data);
    this.onChange({
      changedItem: this,
      updatedData: data,
    });
    return resp;
  }

  delete() {
    return rHandler(
      APIService.delete(`${this.url}/${this.id}`),
      (response) => ({ response }),
      (error) => ({ error }),
    );
  }
}
